import React from 'react'
import { Col } from 'react-bootstrap'
import CustomerGroupsDetails from './FormCustomerGroups__Details'

export default function CustomerGroupsFormContentView(props) {
    const { formik } = props

    return (
        <React.Fragment>
            <div className="app-card mb-3 mb-lg-4">
                <div className="app-header-wrapper heading-sm mb-1">
                    <p className="app-heading text-capitalize">Customer Group Detail</p>
                </div>
                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T">
                    <Col xs={12} md={9} lg={6} className="px-0">
                        <CustomerGroupsDetails
                            formik={formik}
                        />
                    </Col>
                </div>
            </div>

        </React.Fragment>
    )
}
